interface TocEntry {
  id: string;
  heading: string;
}

export default function StoryToc({ entries }: { entries: TocEntry[] }) {
  if (!entries.length) return null;

  return (
    <nav aria-label="本篇目录" className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="flex items-center gap-2 text-sm font-label font-semibold tracking-wide text-foreground-900">
        <i className="ri-list-check-2 text-primary-600" aria-hidden="true"></i>
        本篇目录
      </h2>
      <ol className="mt-3 space-y-2">
        {entries.map((entry, i) => (
          <li key={entry.id}>
            <a
              href={`#${entry.id}`}
              className="flex items-start gap-2 rounded-md px-2 py-1.5 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-primary-700 cursor-pointer"
            >
              <span className="font-heading text-xs text-foreground-400">{String(i + 1).padStart(2, "0")}</span>
              {entry.heading}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}